
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"news",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 computed: {
    rows() {
      return this.list.length
    },
    list(){
      return this.$t('news.list')
    }
  },
 data() {
    return {
      bannerUrl:require("~/static/images/news/banner.jpg"),
      perPage: 3,
      currentPage: 1
    }
  },
}
